// add custom carousel dots on mobile
// let screen = window.innerWidth;

if (screen.width < 1023) {
  window.addEventListener("load", function () {
    new Glider(document.querySelector(".carousel__container"), {
      slidesToShow: 1,
      dots: ".dots",
      draggable: true,
    });
  });
}

// add custom cursor on carousel scroll
if (screen.width > 1023) {
  let cursorArea = document.querySelector(".carousel__section");
  let scrollArea = document.querySelector(".carousel__container");

  function getArrowCursor(e) {
    let offset = scrollArea.scrollLeft;
    let x = e.clientX + offset;
    let half = scrollArea.scrollWidth / 2;

    if (x > half) {
      cursorArea.classList.add("carousel__section--scroll-right");
      cursorArea.classList.remove("carousel__section--scroll-left");
    } else {
      cursorArea.classList.add("carousel__section--scroll-left");
      cursorArea.classList.remove("carousel__section--scroll-right");
    }
  }

  cursorArea.addEventListener("mousemove", getArrowCursor);
}
